/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './external-demand-source-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-external-demand-source-list-page',
  template
})
export class ExternalDemandSourceListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adm.external-demand-sources.external-demand-source';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'externalPartner'},
    {param: 'publisherId'},
    {param: 'apiKey'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }
}
